import ReCAPTCHA from 'react-google-recaptcha';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { verifyCaptcha } from '../../AuthActions';

interface IRecaptcha {
  onVerify: (isVerified: boolean) => void;
}

const Recaptcha = ({ onVerify }: IRecaptcha) => {
  const phoneNumber = useSelector((state: RootState) => state?.auth?.mobileNumber);
  const reloadCaptcha =
    useSelector((state: RootState) => state?.common?.userData?.reloadCaptcha) || false;
  const siteKey = window?.config?.GOOGLE_CAPTCHA_SITE_KEY;
  function onChange(value: any) {
    verifyCaptcha(value, phoneNumber).then(success => {
      if (typeof onVerify === 'function') {
        onVerify(success);
      }
    });
  }
  return (
    <div key={reloadCaptcha}>
      <ReCAPTCHA sitekey={siteKey} onChange={onChange} />
    </div>
  );
};

export default Recaptcha;
